import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {fetchProducts} from '../redux/product/productActions';
import Product from '../components/Product';
import {GiRunningShoe} from "react-icons/gi";

const HomeScreen = () => {
    const productReducer = useSelector(state => state.productReducer);
    const {products, error, loading} = productReducer;
    const dispatch = useDispatch();
    
    useEffect(() =>{
        dispatch(fetchProducts());
    },[dispatch])

    if(loading || error){
        return (
            loading ? <h2>Loading...</h2> : <h2>{error}</h2>
        )
    }

    return (
        <div className="pageContainer" id="home">
            <div className="header">
                <div><GiRunningShoe size={120}/></div>
                <h2 className="pageHeader">ShoeBox</h2>
                <p>Bringing you the latest shoes</p>
            </div>

            <div className="pageBody products">
                {products && products.map(product =><Product key={product._id} product={product}/>)}
            </div>
        </div>
    )
};

export default HomeScreen;
